export enum EstablishmentTypeEnum {
  CARE = 'CARE',
  SUPPORT_FUNCTION = 'SUPPORT_FUNCTION',
}

export const establishmentTypeFrenchTranslation = (type: EstablishmentTypeEnum): any => {
  switch (type) {
    case EstablishmentTypeEnum.CARE:
      return 'Prise en charge';
    case EstablishmentTypeEnum.SUPPORT_FUNCTION:
      return 'Fonction support';
    default:
      return 'Type inconnu';
  }
};

export const establishmentTypeEnglishTranslation = (type: EstablishmentTypeEnum) => {
  switch (type) {
    case EstablishmentTypeEnum.CARE:
      return 'Care';
    case EstablishmentTypeEnum.SUPPORT_FUNCTION:
      return 'Support function';
    default:
      return 'Unknown type';
  }
};

export const establishmentTypeFrenchToEnum = (frenchLabel: string): EstablishmentTypeEnum => {
  switch (frenchLabel) {
    case 'Prise en charge':
      return EstablishmentTypeEnum.CARE;
    case 'Fonction support':
      return EstablishmentTypeEnum.SUPPORT_FUNCTION;
    default:
      throw new Error(`Unknown establishment type: ${frenchLabel}`);
  }
};

export const EstablishmentTypeEnumFrench = Object.values(EstablishmentTypeEnum).map(type =>
  establishmentTypeFrenchTranslation(type),
);

export const EstablishmentTypeEnumEnglish = Object.values(EstablishmentTypeEnum).map(type =>
  establishmentTypeEnglishTranslation(type),
);
